import TripPriceLoader from '../TripPriceLoader';
import { type PriceObject } from '@search/ItineraryPriceLoader';
import { PricesApiApiGetMinPricesGet } from '@clients/TrainApi';

export default class TrainPriceLoader extends TripPriceLoader {
    override async fetchSinglePrices(
        fromDate: Date,
        toDate: Date,
        origin: string,
        destination: string
    ): Promise<PriceObject[]> {
        const { data } = await PricesApiApiGetMinPricesGet({
            from: +origin,
            to: +destination,
            fromDate: fromDate.toISOString(),
            toDate: toDate.toISOString(),
            capacity: this.adultCount + this.childCount,
            genderCode: +(this.priceTypeCode || 3),
        });
        return Object.keys(data).reduce(
            (previousValue, key) => [
                ...previousValue,
                {
                    value: data[key] === '-' ? '-' : +data[key],
                    date: key,
                },
            ],
            [] as PriceObject[]
        );
    }
}
